






















import { stringLength } from '@tt4b/ttam-utils';
import { computed, defineComponent, toRefs } from '@vue/composition-api';

const name = 'ttam-identity-create-name';

export default defineComponent({
  name,
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 40,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const displayNameLen = computed(() => stringLength(value.value?.trim() || ''));
    const onBlur = () => {
      emit('blur');
    };
    const onNameChange = (val: string) => {
      emit('input', val);
    };
    const onFocus = () => {
      emit('focus');
    };
    return {
      name,
      onBlur,
      onFocus,
      displayNameLen,
      onNameChange,
    };
  },
});
